import React from "react";
import InoutLive from "./InoutLive";
import InoutLiveSub from "./InoutLiveSub";
import { Box } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function InoutMain() {
  const [data, setData] = useState([]);
  const location = useLocation();

  const updateData = (live) => {
    setData(live);
  };
  return (
    <Box sx={{ backgroundColor: "#f8f9fa" }}>
      {location.pathname === "/sams/inoutlive" && (
        <InoutLive updateData={updateData} />
      )}
      {location.pathname === "/sams/inoutlive" && <InoutLiveSub data={data} />}
    </Box>
  );
}
